import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { GithubErrorSummary } from '@/api/releaseApproval';
import { formatGithubPermission } from './githubPermission';

/**
 * Why GitHub could not be read (#3470): a token without a permission it needs
 * stays broken until someone fixes the token, an outage passes on its own.
 */
export function GithubErrorAlert({ error }: { error: GithubErrorSummary | null }) {
  const { t } = useTranslation('releaseApproval');
  if (!error) return null;
  if (error.kind === 'permission_missing') {
    return (
      <Alert severity="error" data-testid="github-permission-missing">
        {error.permission
          ? t('github.permissionMissing', { permission: formatGithubPermission(error.permission) })
          : t('github.permissionMissingUnnamed')}
      </Alert>
    );
  }
  return (
    <Alert severity="warning" data-testid="github-unavailable">
      {t('githubUnavailable')}
    </Alert>
  );
}
